import { useEffect, useState, useTransition } from 'react'

function useStateNonblocking<T>(
  callback: () => T,
  dependencyArray: any[],
  initialState: T,
): [T, boolean] {
  const [state, setState] = useState(initialState)
  const [isPending, startTransition] = useTransition()

  useEffect(() => {
    startTransition(() => {
      setState(callback())
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencyArray)

  return [state, isPending]
}

export default useStateNonblocking
